module.exports = __webpack_public_path__ + "img/pax.5b82a3ac.svg";